import React from "react";
import { Hero, Section } from "../components/Page/Page.js";
import { Link } from "react-router-dom";

export default function NotFoundScreen() {
  return (
    <>
      <Hero title="Page not found" text="The page you're looking for doesn't exist." />
      <Section><Link className="pg-btn" to="/">Back to home</Link></Section>
    </>
  );
}
